'use strict';

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _diff = require('diff');

var _util = require('../util');

var _shared = require('./shared');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = function styles(theme) {
  return {
    element: {
      boxDecorationBreak: 'clone',
      padding: [[0, 4]],
      lineHeight: 1.35
    },
    highlight: {
      fontWeight: 'bold',
      color: theme.colorButton
    },
    accept: {
      background: theme.accept
    },
    reject: {
      background: theme.reject
    }
  };
};

function getDiffContent(obj, defaultValue) {
  if ((0, _util.isObject)(obj)) {
    // workaround for accept: [] in choice
    return obj.text || defaultValue;
  }

  return defaultValue;
}
/*
 * Inspied by react-diff: https://github.com/cezary/react-diff
 */


var Diff = (_dec = (0, _util.withStyles)(styles), _dec(_class = (_temp2 = _class2 = function (_React$Component) {
  _inherits(Diff, _React$Component);

  function Diff() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Diff);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Diff.__proto__ || Object.getPrototypeOf(Diff)).call.apply(_ref, [this].concat(args))), _this), _this.getDiff = function (content) {
      var a = content.removed || getDiffContent(content.reject, '');
      var b = content.added || getDiffContent(content.accept, '');

      if (_this.props.config.diffStyle == 'chars') {
        return (0, _diff.diffChars)(a, b);
      }

      if (_this.props.config.diffStyle == 'sentences') {
        return (0, _diff.diffSentences)(a, b);
      }

      return (0, _diff.diffWords)(a, b);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Diff, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          content = _props.content,
          config = _props.config,
          nowrap = _props.nowrap,
          getInterfaceComp = _props.getInterfaceComp,
          classes = _props.classes;
      var input = content.input ? content.input : content.text ? {
        text: content.text
      } : null;
      return _react2["default"].createElement(_react.Fragment, null, input && getInterfaceComp(input, {
        config: config
      }), _react2["default"].createElement(_shared.Content, {
        divider: true,
        cardStyle: config.cardStyle,
        nowrap: nowrap
      }, this.getDiff(content).map(function (_ref2, i) {
        var _classNames;

        var added = _ref2.added,
            removed = _ref2.removed,
            value = _ref2.value;
        var elClassNames = (0, _classnames2["default"])(classes.element, (_classNames = {}, _defineProperty(_classNames, classes.highlight, added || removed), _defineProperty(_classNames, classes.accept, added), _defineProperty(_classNames, classes.reject, removed), _classNames));
        return _react2["default"].createElement('span', {
          key: i,
          className: elClassNames
        }, value);
      })));
    }
  }]);

  return Diff;
}(_react2["default"].Component), _class2.id = 'diff', _temp2)) || _class);
exports["default"] = Diff;